import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

const DEFAULT_TITLE = "Hotel Metropolis — Srinagar";
const DEFAULT_DESCRIPTION = "A luxury stay in the heart of Srinagar, Kashmir.";

export default function SEO({ title, description, image, url }: SEOProps) {
  const pageTitle = title ? `${title} — Hotel Metropolis` : DEFAULT_TITLE;
  const pageDescription = description ?? DEFAULT_DESCRIPTION;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}